import { render, staticRenderFns } from "./TestFooter.vue?vue&type=template&id=74c054d8&scoped=true"
import script from "./TestFooter.vue?vue&type=script&lang=js"
export * from "./TestFooter.vue?vue&type=script&lang=js"
import style0 from "./TestFooter.vue?vue&type=style&index=0&id=74c054d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c054d8",
  null
  
)

export default component.exports